import axios from "axios";

export function getParticipants() {
    return {
        type: "GET_PARTICIPANTS",
        payload: axios.get("/rest/participant")
    }
}

export function addParticipant(participant) {
    return {
        type: "ADD_PARTICIPANT",
        participantId: participant.id,
        participantFirstName: participant.firstName,
        participantFirstNameErrors: validateParticipantFirstName(participant.firstName),
        participantLastName: participant.lastName,
        participantLastNameErrors: validateParticipantLastName(participant.lastName),
        participantBirthDate: participant.birthDate,
        participantBirthDateErrors: validateParticipantBirthDate(participant.birthDate),
        participantGender: participant.gender,
        participantGenderErrors: []
    }
}

export function editParticipant(participant, index) {
    return {
        type: "EDIT_PARTICIPANT",
        participantIndex: index,
        participantId: participant.id,
        participantFirstName: participant.firstName,
        participantFirstNameErrors: validateParticipantFirstName(participant.firstName),
        participantLastName: participant.lastName,
        participantLastNameErrors: validateParticipantLastName(participant.lastName),
        participantBirthDate: participant.birthDate,
        participantBirthDateErrors: validateParticipantBirthDate(participant.birthDate),
        participantGender: participant.gender,
        participantGenderErrors: []
    }
}

export function cancelParticipant() {
    return {
        type: "CANCEL_PARTICIPANT"
    }
}

export function displayValidationErrors() {
    return {
        type: "DISPLAY_PARTICIPANT_VALIDATION_ERRORS"
    }
}

export function saveParticipant(participant) {
    return {
        type: "SAVE_PARTICIPANT",
        payload: participant.id ? axios.put("/rest/participant/" + participant.id, {
            firstName: participant.firstName,
            lastName: participant.lastName,
            birthDate: participant.birthDate,
            gender: participant.gender
        }) : axios.post("/rest/participant", {
            firstName: participant.firstName,
            lastName: participant.lastName,
            birthDate: participant.birthDate,
            gender: participant.gender
        })
    }
}

export function deleteParticipant(participant) {
    return {
        type: "DELETE_PARTICIPANT",
        meta: { participantId: participant.id },
        payload: axios.delete("/rest/participant/" + participant.id)
    }
}

export function updateParticipantFirstName(value) {
    return {
        type: "UPDATE_PARTICIPANT_FIRST_NAME",
        value,
        errors: validateParticipantFirstName(value)
    }
}

export function updateParticipantLastName(value) {
    return {
        type: "UPDATE_PARTICIPANT_LAST_NAME",
        value,
        errors: validateParticipantLastName(value)
    }
}

export function updateParticipantBirthDate(value) {
    return {
        type: "UPDATE_PARTICIPANT_BIRTH_DATE",
        value,
        errors: validateParticipantBirthDate(value)
    }
}

export function updateParticipantGender(value) {
    return {
        type: "UPDATE_PARTICIPANT_GENDER",
        value,
        errors: []
    }
}

export function clearErrors() {
    return {
        type: "CLEAR_ERRORS"
    }
}

function validateParticipantFirstName(value) {
    var errors = [];
    if (!value.match(/^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]*$/)) {
        errors.push("Imię może składać się wyłącznie z liter")
    }
    if (value.length < 2) {
        errors.push("Imię nie może być krótsze niż 2 znaki")
    }
    if (value.length > 20) {
        errors.push("Imię nie może być dłuższe niż 20 znaków")
    }
    return errors;
}

function validateParticipantLastName(value) {
    var errors = [];
    if (!value.match(/^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]+[-]{0,1}[A-Za-zĄąĆćĘęŁłŃńÓóŚśŻżŹź]*$/)) {
        errors.push("Nazwisko może składać się wyłącznie z liter i jednego znaku '-'")
    }
    if (value.length < 2) {
        errors.push("Nazwisko nie może być krótsze niż 2 znaki")
    }
    if (value.length > 40) {
        errors.push("Nazwisko nie może być dłuższe niż 40 znaków")
    }
    return errors;
}

function validateParticipantBirthDate(value) {
    var errors = [];
    if (!value.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        errors.push("Data urodzenia musi być w formacie RRRR-MM-DD")
    } else {
        var year = parseInt(value.substring(0, 4), 10);
        var month = parseInt(value.substring(5, 7), 10) - 1;
        var day = parseInt(value.substring(8, 10), 10);
        var date = new Date(year, month, day);
        if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
            errors.push("Data urodzenia jest nieprawidłowa")
        }
    }
    return errors;
}


// WEBPACK FOOTER //
// ./src/actions/participants.js